import { create, StateCreator } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export function createStoreWithPersistent<T extends object>({
  nameStorage,
  initialState,
  storage = "local",
}: {
  nameStorage: string;
  initialState: StateCreator<T>;
  storage?: "session" | "local";
}) {
  return create<T>()(
    persist(initialState, {
      name: nameStorage,
      storage: createJSONStorage(() =>
        storage === "session" ? sessionStorage : localStorage,
      ),
    }),
  );
}
